import React from 'react';
import { ITEM_LEAVE_CLASS } from 'hooks/useLeavingItems';

/**
 * A list item that fades out then folds its height away (hooks/useLeavingItems).
 *
 * The fold eases a one-row grid down to 0fr, which needs a wrapper without
 * padding nor border around the content: keep those on `children`. A parent
 * spacing its items with `gap` sets the same size in the `--leave-gap` custom
 * property through `className`, so the items below do not jump by one gap at
 * the end.
 *
 * While leaving, the class passed should not carry another animation: an
 * element plays one `animation` value at a time.
 */
const LeavingItem = ({
  as: Tag = 'div',
  leaving = false,
  className = '',
  style,
  children,
  ...props
}) => (
  <Tag
    {...props}
    className={`${leaving ? `grid ${ITEM_LEAVE_CLASS}` : ''} ${className}`}
    // An entrance delay left on the item would hold its exit back.
    style={leaving ? { ...style, animationDelay: '0ms' } : style}
  >
    <div className={leaving ? 'min-h-0 overflow-hidden' : undefined}>
      {children}
    </div>
  </Tag>
);

export default LeavingItem;
